export default "__VITE_ASSET__BBXhvkY7__"